import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { FeaturesSection } from './components/FeaturesSection';
import { AudienceSection } from './components/AudienceSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#FAF8F5] font-sans text-[#44403C]" data-id="element-0">
      {/* Navigation / Header */}
      <nav className="py-4 px-6 bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-[#F5F1EB]" data-id="element-1">
        <div className="container mx-auto flex justify-between items-center" data-id="element-2">
          <div className="font-bold text-xl tracking-tight text-[#44403C]" data-id="element-3">
            Low-Tox <span className="text-[#8B9D83]" data-id="element-4">Mama</span>
          </div>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-sm font-medium text-[#C97D60] hover:text-[#B56B50] transition-colors" data-id="element-5">
            Obtener Guía
          </button>
        </div>
      </nav>

      <main data-id="element-6">
        <Hero data-id="element-7" />
        <ProblemSection data-id="element-8" />
        <SolutionSection data-id="element-9" />
        <FeaturesSection data-id="element-10" />
        <AudienceSection data-id="element-11" />
        <PricingSection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}